import type {ReactElement} from 'react';
import DialogBase from '@components/Dialog/DialogBase';
import LoadingSpinner from '@components/LoadingSpinner/LoadingSpinner';
import styles from './loadingDialog.module.scss';

interface Props {
    isOpen: boolean;
}

export default function LoadingDialog(props: Props): ReactElement<Props> {
    return (
        <DialogBase isOpen={props.isOpen}>
            <div className={styles.dialog}>
                <LoadingSpinner />
            </div>
        </DialogBase>
    );
}

LoadingDialog.defaultProps = {
    isOpen: false,
};
